import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CentroMedico, Medicos, ResponseApiModel } from "../interfaces";
import { environment } from "@environments/environment";

@Injectable({
    providedIn: 'root',
})
export class DatosMedicosService {
    private readonly _httpClient = inject(HttpClient)

    obtenerMedicosAsistentePorEmpresa(idEmpresa: string): Observable<ResponseApiModel<Array<Medicos>>> {
        return this._httpClient.get<ResponseApiModel<Array<Medicos>>>(`${environment.baseURL}datos-medicos/medicos/asistente/${idEmpresa}`);
    }

    obtenerCentrosMedicosPorMedico(idMedico: string, idEmpresa: string): Observable<ResponseApiModel<Array<CentroMedico>>> {
        return this._httpClient
            .get<ResponseApiModel<Array<CentroMedico>>>(`${environment.baseURL}datos-medicos/centros-medicos/${idMedico}/${idEmpresa}`);
    }
}